document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector("#Search-In-Modal");
  const box = document.querySelector("#predictive-container");

  if (!input || !box) return;

  input.addEventListener("input", async (e) => {
    const query = e.target.value.trim();
    if (query.length < 3) {
      box.style.display = "none";
      return;
    }

    const gqlQuery = `
      {
        products(first: 10, query: "${query}") {
          edges {
            node {
              title
              handle
              featuredImage { url }
            }
          }
        }
      }
    `;

    try {
      const response = await fetch("/api/2024-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": window.storefrontAccessToken,
        },
        body: JSON.stringify({ query: gqlQuery }),
      });

      const result = await response.json();

      const products = result?.data?.products?.edges || [];

      // ❌ No results? Hide
      if (products.length === 0) {
        box.style.display = "none";
        return;
      }

      // 🧱 Build HTML
      let html = "";
      products.forEach(({ node }) => {
        html += `
          <div class="predictive-item" onclick="window.location='/products/${node.handle}'">
            <img src="${node.featuredImage?.url || ''}" />
            <div>${node.title}</div>
          </div>
        `;
      });

      // Inject and show
      box.innerHTML = html;
      box.style.display = "block";

    } catch (err) {
      console.error("GQL Error", err);
    }
  });
}); 